import {
  ActionsCard,
  Badge,
  ButtonColors,
  ButtonSizes,
  LinkButton,
} from 'components';
import { formatActionStepLabel } from 'helpers/submetrics/formatActionStepLabel';
import { sortActionsByStep } from 'helpers/submetrics/sortActionsByStep';
import useCurrentKitAndTinyAccount from 'hooks/useCurrentKitAndTinyAccount';
import { Fragment } from 'react';
import { ActionPlanItemWithStep } from 'types/ActionPlan';
import { ActionPlanItemCard } from 'views/ActionPlan/ActionPlanGroupV2/ActionPlanGroupV2';
import styles from './SubMetricDetail.module.css';

export const RelatedActions = ({
  actions,
  className,
}: {
  actions: ActionPlanItemWithStep[];
  className?: string;
}) => {
  const { currentKitId } = useCurrentKitAndTinyAccount();
  if (!currentKitId) {
    return null;
  }

  // Hide the Action Items card entirely when there are no related actions
  // (ENG-4509). The surrounding column keeps its width because the card's
  // wrapper element remains in the layout.
  if (!actions?.length) return null;

  const sortedActions = sortActionsByStep(actions);

  return (
    <ActionsCard
      title='Action Items'
      actions={sortedActions}
      className={className}
      renderItem={(action, index) => {
        const item = action as ActionPlanItemWithStep;
        // Render a step header on each group boundary (items are step-sorted).
        const showStepHeader =
          item.step != null && item.step !== sortedActions[index - 1]?.step;
        const stepLabel = formatActionStepLabel(item.step, item.stepText);
        return (
          <Fragment key={item.id}>
            {showStepHeader && stepLabel && (
              <Badge
                title={stepLabel}
                state='default'
                variant='eyebrow'
                className={styles.stepLabelBadge}
              />
            )}
            <ActionPlanItemCard action={item} kitId={currentKitId} />
          </Fragment>
        );
      }}
    >
      <LinkButton
        href={`/action-plan/${currentKitId}`}
        size={ButtonSizes.M}
        color={ButtonColors.PURPLE}
        label='Go to action plan'
        width={'full'}
        className='mt-4'
      />
    </ActionsCard>
  );
};
